// Fire off verification on page load
document.addEventListener('DOMContentLoaded', function() {
    isAgeVerified();
});

// Handle the verification button
document.getElementById('verify-yes').addEventListener('click', function(e){
    e.preventDefault();

    clearAgeVerification();

    const expDate = new Date().setDate(new Date().getDate() + 30); // 30 days

    localStorage.setItem('ageVerification', 'verified');
    localStorage.setItem('ageVerificationExpires', expDate);

    var legalNoticeEl = document.getElementById('legal-notice');
    legalNoticeEl.style.display = "none";

    var html = document.documentElement;
    html.classList.remove('verify-age');

    var heroVideo = document.getElementById("hero-video");
    if( heroVideo.length > 0 ){
        heroVideo.currentTime = 0;
        heroVideo.play();
    }

    // location.reload();
});

// Clear the session age verification when browser is openened 
// const  clearStorage = () =>  {
//     clearAgeVerification();
// }
// window.addEventListener('load', clearStorage);

// Check if the page is verified
function isAgeVerified(){

    // Set up 
    const curDate = new Date().getDate();

    let legalNoticeEl = document.getElementById('legal-notice');
    let html = document.documentElement;

    let ageVerification = localStorage.getItem('ageVerification');
    let ageVerificationExpires = localStorage.getItem('ageVerificationExpires');

    // check if we have already verified the age:
    if( ageVerification === 'verified' && ( null !== ageVerificationExpires && curDate < ageVerificationExpires ) ){
        html.classList.remove('verify-age');
        legalNoticeEl.style.display = "none";
    }else{
        clearAgeVerification();

        html.classList.add('verify-age');
        legalNoticeEl.style.display = "block";

        var heroVideo = document.getElementById("hero-video");
        if( heroVideo.length > 0 ){
            heroVideo.pause();
            heroVideo.currentTime = 0;
        }
    }

    // if(ageVerification != 'verified') {
    //     html.classList.add('verify-age');
    //     legalNoticeEl.style.display = "block";

    //     var heroVideo = document.getElementById("hero-video");
    //     if( heroVideo.length > 0 ){
    //         heroVideo.pause();
    //         heroVideo.currentTime = 0;
    //     }
    // }else{
    //     html.classList.remove('verify-age');
    //     legalNoticeEl.style.display = "none";
    // }
}

function clearAgeVerification(){
    localStorage.removeItem('ageVerification');
    localStorage.removeItem('ageVerificationExpires');
}